import Cookies from "js-cookie"
import { all, call, put, select } from "redux-saga/effects"

import api from "apis"
import { setExperiment } from "app-store-v2/app/actions"
import { history } from "app-store-v2/index"
import { setCart } from "areas/cart/store/actions"
import { closeModal, openModal } from "components/modal"
import { isTestMode } from "helpers/application"
import { setClickedOnHistoryCookie } from "helpers/collection"

import {
  showError,
  fetchInventory,
  forceHideMiniview,
  forcePanelIndex,
  cancelAddToCart,
  scrollPanelIndex,
} from "../actions"
import { getRequiredMessages, toFormObject } from "../helpers/choices"

export default function* addToCart() {
  let state = yield select()
  const cartToken = Cookies.get(sl.config.cookies_config.cart_token)
  const { ef } = state.wizard.data
  const allow_partial_engravings = ef?.allow_partial_engravings
  const allErrors = {}
  let minErrorEngravingFont = null
  const tempMinCharsErrors = {}
  const minCharsErrorKeysForCount = []
  let engravingFieldCount = 0

  // 1. Min Chars errors
  for (var key in state.wizard.data) {
    if (key[0] == "e" && state.wizard.data[key].min_chars) {
      if (state.wizard.data[key].min_chars > 0) {
        engravingFieldCount += 1
        // These are the ERROR conditions
        if (
          !state.choices[key] ||
          !state.choices[key].value ||
          state.choices[key].value.trim().length === 0 ||
          state.choices[key].value.length < state.wizard.data[key].min_chars ||
          (state.choices[key].value.length >=
            state.wizard.data[key].min_chars &&
            state.choices[key].is_default)
        ) {
          if (state.choices[key] && state.choices[key].disabled) {
            continue
          }
          minCharsErrorKeysForCount.push(key)
          if (state.wizard.hasDiamondSelector) {
            if (!state.choices[key]) {
              continue
            }
            tempMinCharsErrors["m2"] =
              "Please select your initials for the Signature Setting."
          } else {
            minErrorEngravingFont =
              state.wizard.data[key].engraving_font || "ef"
            tempMinCharsErrors[key] = state.wizard.data[key].missing_msg
          }
        }
      }
    }
  }

  const minCharsErrorKeys = Object.keys(tempMinCharsErrors)
  if (minCharsErrorKeys.length > 0) {
    if (!allow_partial_engravings) {
      Object.assign(allErrors, tempMinCharsErrors)
    } else if (minCharsErrorKeysForCount.length === engravingFieldCount) {
      allErrors[minCharsErrorKeys[0]] = tempMinCharsErrors[minCharsErrorKeys[0]]
    }
  }

  // 2. Diamond selector final_diamond error
  if (state.wizard.hasDiamondSelector) {
    if (
      state.diamondUI.steps[state.diamondUI.currentStep] !== "final_diamond"
    ) {
      allErrors["s1"] = state.wizard.data.s1?.missing_msg || true
    }
  }

  // 3. Required messages errors
  const requiredMessages = getRequiredMessages(state)
  Object.assign(allErrors, requiredMessages)

  const errorKeys = Object.keys(allErrors)

  if (errorKeys.length > 0) {
    yield put(forceHideMiniview("scroll", true))

    // Set all error messages
    const errorActions = errorKeys.map((k) =>
      put(showError(k, allErrors[k] || true))
    )
    yield all(errorActions)

    const prefOrder = state.wizard.prefOrder || []

    const getPanelKey = (k) => {
      let mappedKey = k
      if (state.wizard.hasDiamondSelector) {
        if (
          k == "s1" ||
          ["d_carat", "d_cut", "d_clarity", "d_shape", "d_color"].indexOf(k) !==
            -1
        ) {
          mappedKey = "diamond"
        } else if (k == "e1" || k == "e2") {
          mappedKey = "m2"
        }
      }

      if (mappedKey[0] == "e") {
        mappedKey = minErrorEngravingFont || "ef"
      }
      return mappedKey
    }

    const mappedErrorKeys = errorKeys.map(getPanelKey)
    const firstPrefName = prefOrder.find((pref) =>
      mappedErrorKeys.includes(pref)
    )
    const pref_name = firstPrefName || mappedErrorKeys[0]

    if (
      pref_name === "sz" &&
      sl.config.show_guaranteed &&
      state.wizard.shipping?.main?.available_holiday_delivery &&
      state.wizard.hasInventory
    ) {
      yield put(fetchInventory({ get_all_sizes: true }))
    }

    yield put(forcePanelIndex(pref_name))
    yield put(scrollPanelIndex(pref_name))

    if (!isTestMode) {
      dataLayer.push({
        event: "missed-product-option",
        optionName: pref_name,
        styleCode: state.choices.style_code?.value,
      })
    }

    yield put(cancelAddToCart())
    return
  } else if (history.action !== "PUSH") {
    closeModal()
  }

  // If no errors, proceed with add to cart
  // $.ajax({
  //   url: '/cart/add',
  //   type: 'POST',
  //   data: $('#item-form').serialize(),
  //   success: function(result) {
  //     window.location.href = '/cart';
  //   },
  //   error: function(result) {
  //   }
  // });
  // Remove debug flag

  var has_default_images = false
  // if ($(".image_input").is("*")) {
  //   $(".image_input").each(function() {
  //     //Is it a user uploaded photo
  //     if (
  //       $(this)
  //         .val()
  //         .indexOf("user_uploads/") === -1
  //     ) {
  //       has_default_images = $(this).attr("name")
  //     }
  //   })
  // }

  if (has_default_images) {
    if (
      !confirm(
        "Are you sure you would like to use the stock photography for this pendant?\nPress OK to Add to Cart, or Cancel to modify."
      )
    ) {
      yield put(forceHideMiniview("scroll", true))
      yield put(cancelAddToCart())
      return
    }
  }

  window.onbeforeunload = null

  if (state.wizard.formUrl) {
    try {
      const editForm = document.querySelector("#edit-form")
      editForm.submit()
    } catch (error) {
      window.alert("Something is wrong")
    }
    return
  }

  let formObj = toFormObject(state)
  formObj = { ...formObj }

  // Save clicked on history in the collectionStats cookie
  setClickedOnHistoryCookie(formObj.style_code)

  var result = yield call(api.post, `/api/v10/cart/${cartToken}`, formObj)
  const { data } = result
  if (data.success) {
    // Update cart
    yield put(setCart(data.cart))

    if (!isTestMode) {
      try {
        // Most recently added item is first in the list
        const addedLineItem =
          data.cart.line_items.find(
            (li) => li.id === data.cart.latest_line_item_id
          ) ?? data.cart.line_items[0]
        var sale_price = addedLineItem.sale_price
        let boxAddon = addedLineItem.addons.find(
          (addon) => addon.addon_type === "BOX_PRINT"
        )

        dataLayer.push({
          addedItem: {
            itemCurrencyCode: addedLineItem.currency_code,
            itemDetails: addedLineItem.view_item_details.slice(1),
            itemImageUrl: addedLineItem.image_url,
            itemMetal: addedLineItem.sku,
            itemPrice: addedLineItem.price,
            itemRegularPrice: addedLineItem.regular_price,
            itemSalePrice: sale_price,
            itemShorthand: addedLineItem.item_shorthand,
            itemStyleCode: addedLineItem.style_code,
            itemTitle: addedLineItem.title,
            itemUrl: addedLineItem.full_product_url,
            itemVariant: addedLineItem.item_variant,
            pinterestEventId: data.cart.summary.token + "-" + addedLineItem.id,
            uniqueEventId: data.cart.summary.token + "-" + addedLineItem.id,
          },
          cartLineItems: data.cart.line_items_gtm,

          currencyCode: addedLineItem.currency_code,
          // GA Enhanced Ecommerce
          ecommerce: {
            add: {
              products: [
                {
                  category: addedLineItem.collection_url,
                  id: addedLineItem.item_shorthand,
                  name: addedLineItem.style_code,
                  price: addedLineItem.price,
                  quantity: 1,
                  variant: "",
                },
              ],
            },
            currencyCode: addedLineItem.currency_code,
          },
          event: "added-to-cart",
          // GA4 Variable
          ga4Items: [
            {
              currency: sl.config.currency_code,
              item_category: addedLineItem.product_category,
              item_id: addedLineItem.item_variant,
              item_list_name: addedLineItem.collection_url,
              item_name: addedLineItem.style_code_gtm,
              price: addedLineItem.price,
              quantity: 1,
              variant: addedLineItem.sku,
            },
          ],
          // END GA4 Variable
          gaEventAction: "add_to_cart",
          gaEventCategory: "Product",
          gaEventLabel: addedLineItem.item_shorthand,
          gaEventNonInteraction: true,
          gaEventValue: addedLineItem.price,
          orderToken: data.cart.summary.token,
          photoBoxAdded: boxAddon ? true : false,
          productPrice: addedLineItem.price,
          productSku: addedLineItem.sku,
          productTitle: addedLineItem.title,
          productType: addedLineItem.product_type,
          styleCode: addedLineItem.style_code,
          supplier: addedLineItem.supplier,
        })

        if (boxAddon) {
          let userPhoto =
            addedLineItem.full_product_url.includes("user_uploads")
          dataLayer.push({
            event: "photobox-added-to-cart",
            photoBoxPrice: boxAddon.price,
            photoBoxType: userPhoto ? "user-photo" : "regular",
          })
        }

        // const warrantyAddon = addedLineItem.addons.find(
        //   (addon) => addon.addon_type === "WARRANTY"
        // )
        // if (warrantyAddon) {
        //   dataLayer.push({
        //     event: "added-warranty-to-cart",
        //     warrantyPlan: warrantyAddon.addon_code,
        //   })
        // }
      } catch (e) {
        console.log("Added to Cart dataLayer error", e)
      }
    }

    openModal("#show-cart-item")

    const atcHoldbackExp = state.experiment.atcHoldback
    yield put(setExperiment({ atcHoldback: atcHoldbackExp }))

    // We're not actually cancelling the add to cart here,
    // it just resets the "Adding to Cart" button so
    // subsequent PDP pages aren't frozen
    yield put(cancelAddToCart())
  } else {
    // TODO: Better error message for Add to Cart
    alert(data.message)
    yield put(cancelAddToCart())
  }

  // try {
  // var hc = hitFallback(function() {
  //   try {
  //     $("#defaultCatch").remove()
  //     $("#item-form").submit()
  //   } catch (e) {
  //     $("#item-form").submit()
  //   }
  // })

  // } catch (e) {
  //   $("#defaultCatch").remove()
  //   $("#item-form").submit()
  // }
}
